"use strict";
var core_1 = require('@angular/core');
var tag_cloud_component_1 = require('./tag-cloud.component');
var TagCloudModule = (function () {
    function TagCloudModule() {
    }
    TagCloudModule.decorators = [
        { type: core_1.NgModule, args: [{
                    declarations: [tag_cloud_component_1.TagCloudComponent],
                    exports: [tag_cloud_component_1.TagCloudComponent]
                },] },
    ];
    /** @nocollapse */
    TagCloudModule.ctorParameters = function () { return []; };
    return TagCloudModule;
}());
exports.TagCloudModule = TagCloudModule;
//# sourceMappingURL=tag-cloud.module.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-tag-cloud-module/dist/tag-cloud.module.js
 ** module id = 919
 ** module chunks = 0
 **/